import React, { useState, useRef, useEffect } from "react";
import { Send, MessageCircle } from "lucide-react";

const INITIAL = [
  { from: "concierge", text: "Bonjour. This is the Joseph Poche concierge. How may I assist you today?" },
];
const REPLIES = {
  "legacy": "The Legacy Edition is acquired by appointment. May I open a private consultation for you? A senior atelier will respond within 24 hours.",
  "fit": "Of course. Could you tell me your usual frame width and bridge measurement? I will recommend three silhouettes built for your contour.",
  "ship": "Complimentary worldwide shipping, fully insured. 5–9 days standard, 2–3 days express. Every piece arrives with a numbered certificate.",
  "warranty": "Every POCHE piece includes a 2-year house warranty covering hinges, lens coatings, and craftsmanship. Register your piece in the Authenticity tab.",
};
const detect = (q) => {
  const s = q.toLowerCase();
  if (s.includes("legacy")) return REPLIES.legacy;
  if (s.includes("fit") || s.includes("size")) return REPLIES.fit;
  if (s.includes("ship") || s.includes("delivery")) return REPLIES.ship;
  if (s.includes("warranty") || s.includes("return")) return REPLIES.warranty;
  return "I will pass this to our concierge team. You may also reach us at concierge@josephpoche.com or WhatsApp +1 (212) 555-0177.";
};

export default function AppConcierge() {
  const [msgs, setMsgs] = useState(INITIAL);
  const [input, setInput] = useState("");
  const endRef = useRef(null);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const send = () => {
    if (!input.trim()) return;
    const q = input;
    setMsgs((m) => [...m, { from: "you", text: q }]);
    setInput("");
    setTimeout(() => {
      setMsgs((m) => [...m, { from: "concierge", text: detect(q) }]);
    }, 700);
  };

  return (
    <div data-testid="app-concierge" className="pb-6 flex flex-col" style={{ minHeight: "calc(100vh - 80px)" }}>
      <header className="px-5 pt-12 pb-3 border-b border-white/10 flex items-center gap-3">
        <div className="w-10 h-10 bg-poche-gold rounded-full flex items-center justify-center text-poche-black">
          <MessageCircle size={18} />
        </div>
        <div>
          <div className="font-serif text-lg">Concierge</div>
          <div className="text-[10px] tracking-luxury uppercase text-poche-gold flex items-center gap-2"><span className="dot-pulse" /> Online</div>
        </div>
      </header>

      <div className="flex-1 px-5 py-4 space-y-3 overflow-y-auto">
        {msgs.map((m, i) => (
          <div key={i} className={`flex ${m.from === "you" ? "justify-end" : "justify-start"}`} data-testid={`msg-${m.from}-${i}`}>
            <div className={`max-w-[78%] px-4 py-3 text-sm ${m.from === "you" ? "bg-poche-gold text-poche-black" : "bg-poche-ink border border-white/10 text-white"}`}>
              {m.text}
            </div>
          </div>
        ))}
        <div ref={endRef} />
      </div>

      <div className="px-3 pb-3 flex gap-2 border-t border-white/10 pt-3">
        <input
          data-testid="concierge-input"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && send()}
          placeholder="Ask anything…"
          className="flex-1 bg-transparent border border-white/15 px-3 py-2.5 text-sm focus:border-poche-gold focus:outline-none"
        />
        <button data-testid="concierge-send" onClick={send} className="bg-poche-gold text-poche-black px-3 flex items-center"><Send size={14} /></button>
      </div>
    </div>
  );
}
